/**
 * Every page in the internal webapp.
 *
 * A static list, because nothing serves one any more. Per-page access control —
 * a backend registry, a Firestore store of live overrides and an `/access`
 * screen — was removed while no page needed it, so there is no per-viewer
 * answer to ask for. Every signed-in employee sees every entry here.
 *
 * The rail and the launcher both read this, so a page appears in both or in
 * neither. Add an entry when you add its route under `src/routes`.
 */
export interface InternalPage {
  id: string
  path: string
  title: string
}

export const INTERNAL_PAGES: readonly InternalPage[] = Object.freeze([
  {
    id: 'blytzcollect-funnel',
    path: '/blytzcollect/funnel',
    title: 'BlytzCollect call funnel'
  },
  { id: 'example-feedback', path: '/example/feedback', title: 'Example form' }
])

/**
 * Compare two route paths without tripping over a trailing slash or a query.
 *
 * The rail marks the active row with this, so `/example/feedback/` and
 * `/example/feedback?from=x` must both match the declared path.
 *
 * @param pathname - The path to normalize.
 * @returns The path without its query string or trailing slash.
 */
export function normalizePath(pathname: string): string {
  const path = pathname.split('?')[0]

  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
}
